import { showToast } from 'shared/ui'
import { writeTextToClipboard } from 'shared/lib/writeTextToClipboard'

export const copyClientSecret = async (secret: string): Promise<boolean> => {
  try {
    await writeTextToClipboard(secret)
    showToast({ type: 'info', title: 'Copied to clipboard' })
    return true
  } catch {
    showToast({ type: 'error', title: 'Failed to copy client secret' })
    return false
  }
}
